import { Injector } from '@angular/core';
import { combineLatest, of } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { MenuEntry } from '@nimbus-library/features/menu/models/menu-entry.model';
import { MenuEntryViewModel } from '@nimbus-library/features/menu/models/menu-entry.view-model';
import { MenuFilterFactory } from '@nimbus-library/features/menu/services/factories/menu-filter.factory';

export class MenuEntryMapper {
  private readonly filterFactory: MenuFilterFactory;

  public constructor() {
    this.filterFactory = new MenuFilterFactory();
  }

  public handle(menuEntry: MenuEntry, injector: Injector): MenuEntryViewModel {
    const filter$ = combineLatest(
      menuEntry.filters.length !== 0 ? menuEntry.filters.map((filter) => this.filterFactory.createFilter$(filter, injector)) : [of(true)],
    ).pipe(
      map((results) => results.every((result) => !!result)),
      distinctUntilChanged(),
    );

    const subEntries: MenuEntryViewModel[] = menuEntry.subEntries
      ? menuEntry.subEntries.map((subEntry) => this.handle(subEntry, injector))
      : [];

    return new MenuEntryViewModel(
      menuEntry.route.name,
      menuEntry.icon,
      menuEntry.indicator,
      filter$,
      menuEntry.route.path,
      subEntries,
      menuEntry.subClass,
      (menuEntry.connectedPaths || []).filter((c) => !!c.path).map((c) => c.path),
      menuEntry.customImageUrl$,
      menuEntry.customTooltip$,
      menuEntry.renderAs,
    );
  }
}
